export default "__VITE_ASSET__C6uVW$Sb__"